import { Link, useParams } from 'react-router-dom';
import styles from './courseViewDetail.module.scss';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import BreadCrumb from '../Breadcrumb';
import { getProblemById } from '~/api/problems';
import { getSubjectNameByClassID } from '~/api/courses';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlack } from '@fortawesome/free-brands-svg-icons';
import { faBook, faGear } from '@fortawesome/free-solid-svg-icons';
import { getRole } from '~/api/auth';

function CourseViewDetailComponent({ state, mainChild }) {
    const { id, problem_id, topic_problems_id } = useParams();
    const [role, setRole] = useState('guest');

    // const [pages, setPages] = useState(['Exercise', 'Results', 'Settings']);
    const pages = {
        Exercise: `/courses/${id}/topic_problems/${topic_problems_id}/problems/${problem_id}/view`,
        Results: `/courses/${id}/topic_problems/${topic_problems_id}/problems/${problem_id}/overview_submissions`,
        Settings: `/courses/${id}/topic_problems/${topic_problems_id}/problems/${problem_id}/settings`,
    };

    const [problem, setProblem] = useState({
        id: 0,
        title: '',
        level_id: 0,
        level_name: '',
        description: '',
    });
    const [subjectName, setSubjectName] = useState('');

    useEffect(() => {
        const fetchRelevantName = async (id, problem_id) => {
            const res = await getProblemById(problem_id);
            setProblem(res.body);

            const fetchSubjectName = await getSubjectNameByClassID(id);
            setSubjectName(fetchSubjectName.body.subject_name);
        };

        fetchRelevantName(id, problem_id);
    }, [id, problem_id]);

    useEffect(() => {
        (async () => {
            const fetchRole = await getRole();
            setRole(fetchRole.body.role);
        })();
    }, []);

    return (
        <div className={clsx(styles.courseViewDetail)}>
            <div className={clsx('container')}>
                <div className={clsx(styles.innerContainer)}>
                    <div className="pt-3">
                        <BreadCrumb
                            items={['Home', 'My courses', subjectName, problem.title]}
                            links={['/', '/courses', `/courses/${id}/course`]}
                        />
                    </div>
                    <div className={clsx(styles.header)}>
                        <div className={clsx(styles.headerIcon)}>
                            <FontAwesomeIcon icon={faSlack} />
                        </div>
                        <div className={clsx(styles.headerContent)}>
                            <div className={clsx(styles.headerSubTitle)}>Exercise</div>
                            <div className={clsx(styles.headerTitle)}>{problem.title}</div>
                        </div>
                    </div>
                    {(role === 'teacher' || role === 'admin') && (
                        <div className={clsx(styles.navigation)}>
                            {Object.keys(pages).map((p, index) => {
                                if (p.toLowerCase() === state) {
                                    return (
                                        <Link className={clsx(styles.navItem, styles.navItemActive)}>
                                            <div className={clsx(styles.navigationIcon)}>
                                                {p === 'Exercise' && <FontAwesomeIcon icon={faSlack} />}
                                                {p === 'Results' && <FontAwesomeIcon icon={faBook} />}
                                                {p === 'Settings' && <FontAwesomeIcon icon={faGear} />}
                                            </div>
                                            <div>{p}</div>
                                        </Link>
                                    );
                                } else {
                                    return (
                                        <Link className={clsx(styles.navItem)} to={pages[p]}>
                                            <div className={clsx(styles.navigationIcon)}>
                                                {p === 'Exercise' && <FontAwesomeIcon icon={faSlack} />}
                                                {p === 'Results' && <FontAwesomeIcon icon={faBook} />}
                                                {p === 'Settings' && <FontAwesomeIcon icon={faGear} />}
                                            </div>
                                            <div>{p}</div>
                                        </Link>
                                    );
                                }
                            })}
                        </div>
                    )}
                    <div>{mainChild}</div>
                </div>
            </div>
        </div>
    );
}

export default CourseViewDetailComponent;
